
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates",
      function () {
        return require("private-next-pages/templates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates"])
      });
    }
  